<template>
    <MainContainer :hideSidebar="true">
        <b-row align-h="center">
            <b-col cols="4">
                <Login />
            </b-col>
        </b-row>
    </MainContainer>
</template>

<script>
import MainContainer from "@/components/MainContainer/MainContainer";
import Login from "@/components/Login/Login";

export default {
    name: "login",
    components: {
        MainContainer,
        Login
    }
};
</script>